import axios from 'axios'
import apiErrorHandler from '../utils/apiErrorHandler'
import store from '@/store'
async function getAllEconomicGroups({ page, query, partner, withBuyer,  withEconomicGroupRule, requiredBuyer }) {
    try {
        //store.commit('user/setLoading', true)
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/economicgroup`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            },
            params: {
                page,
                query,
                partner,
                withBuyer,
                withEconomicGroupRule,
                requiredBuyer,
            }
        })
        //store.commit('user/setLoading', false)
        store.commit('group/setGroups', result.data.payload.rows)
        store.commit('group/setGroupsPagination', result.data.payload.pagination)
        return result
    } catch (e) {
        //store.commit('user/setLoading', false)
        apiErrorHandler(e.response)
        return e.response
    }

}

export default getAllEconomicGroups